// Refactor, store this as entities and load from server
const statusIds = {
  CREATED: 1,
  SCHEDULED: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
  SENDING: 5,
  MIGRATION_PROCESSING: 6,
  MIGRATION_PENDING_APPROVAL: 7,
  MIGRATION_FAILED: 8,
};
const statusIdNames = {
  1: 'CREATED',
  2: 'SCHEDULED',
  3: 'IN_PROGRESS',
  4: 'COMPLETED',
  5: 'SENDING',
  6: 'MIGRATION_PROCESSING',
  7: 'MIGRATION_PENDING_APPROVAL',
  8: 'MIGRATION_FAILED',
};

// Refactor, store this as entities and load from server
const statusNames = {
  CREATED: 'CREATED',
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  SENDING: 'SENDING',
  COMPLETED: 'COMPLETED',
  MIGRATION_PROCESSING: 'MIGRATION_PROCESSING',
  MIGRATION_PENDING_APPROVAL: 'MIGRATION_PENDING_APPROVAL',
  MIGRATION_FAILED: 'MIGRATION_FAILED',
};

const surveyStatus = [
  { id: statusIds.CREATED, name: 'CREATED', label: 'survey.status0' },
  { id: statusIds.SCHEDULED, name: 'SCHEDULED', label: 'survey.status1' },
  { id: statusIds.IN_PROGRESS, name: 'IN_PROGRESS', label: 'survey.status2' },
  { id: statusIds.COMPLETED, name: 'COMPLETED', label: 'survey.status3' },
  { id: statusIds.SENDING, name: 'SENDING', label: 'survey.status4' },
  { id: statusIds.MIGRATION_PROCESSING, name: 'MIGRATION_PROCESSING', label: 'survey.status5' },
  { id: statusIds.MIGRATION_PENDING_APPROVAL, name: 'MIGRATION_PENDING_APPROVAL', label: 'survey.status6' },
  { id: statusIds.MIGRATION_FAILED, name: 'MIGRATION_FAILED', label: 'survey.status7' },
];

const surveyReminderStatusNames = {
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  PROCESSING: 'PROCESSING',
  ERROR: 'ERROR',
};

export enum SurveyActions {
  cloneSurvey = 'cloneSurvey',
  deleteSurvey = 'deleteSurvey',
  cancelSurvey = 'cancelSurvey',
  editSurvey = 'editSurvey',
  viewReminder = 'viewReminder',
  hideReminder = 'hideReminder',
  previewSurvey = 'previewSurvey',
  approveMigration = 'approveMigration',
  completeSurvey = 'completeSurvey',
  restartSurvey = 'restartSurvey',
  convertToContinuous = 'convertToContinuous',
  clearSurveyCache = 'clearSurveyCache',
}

export enum ContinuousSurveyType {
  Onboarding = 'Onboarding',
  Exit = 'Exit',
}

const reportingStatusIds = [statusIds.SENDING, statusIds.IN_PROGRESS, statusIds.COMPLETED];

export { statusIds, statusIdNames, statusNames, surveyStatus, surveyReminderStatusNames, reportingStatusIds };
